import React from "react"
import "./style.scss"
import Modal from "react-bootstrap/Modal"
import { IoMdThumbsUp } from "react-icons/io"

const Success = ({
  show,
  successText = "Thanks for contacting us! We will be in touch with you shortly.",
}) => {
  return (
    <Modal
      dialogClassName="success-width"
      show={show}
      centered
      className="success-modal"
    >
      <div className="like-container">
        <IoMdThumbsUp className="like" color="#fff" />
      </div>
      <h1 className="success-message">
        {successText && successText.split("!")[0]}
      </h1>
      <p className="success_subtext">
        {successText && successText.split("!")[1]}
      </p>
      <Modal.Body></Modal.Body>
    </Modal>
  )
}

export default Success
